import React from "react";
import { graphql } from "gatsby";
import PlaneIcon from "../images/subscribe-plane.svg";
import { motion, AnimatePresence } from "framer-motion";
import { HubspotProvider, useHubspotForm } from "react-use-hubspot-form";

export const motionProps = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
  transition: { duration: 0.4 },
};

export const fragments = graphql`
  fragment Page_NewsletterSignup on PrismicPageDataBodyNewsletterSignup {
    id
  }
`;

const HubspotSubscribeForm = ({cls}) => {
  useHubspotForm({
    region: "na1",
    portalId: "22158483",
    formId: "6da59470-0f29-47f8-b523-06e8ccab891b",
    target: "#hubspotSubscribeForm",
  });

  return (
    <div className={`subscribe ${cls ? cls : ''}`}>
      <AnimatePresence mode="wait">
        <motion.div {...motionProps} className="subscribe__box" key={2}>
          <div className="subscribe__icon">
            <PlaneIcon />
          </div>
          <div id="hubspotSubscribeForm" />
          {/* {!submitted ? (
          <motion.div {...motionProps} className="subscribe__box" key={2}>
            <div className="subscribe__icon">
              <PlaneIcon />
            </div>
            <form onSubmit={handleSubmit}>
              <h3 className="h3">Insights in your inbox</h3>
              <p className="p-md">
                Sign up to get new ideas and inspiration each quarter!
              </p>
              <div className="subscribe__field">
                <input placeholder="Email" name="email" type="email" required />
                <button aria-label="Submit subscription">
                  <ArrowSvg />
                  <span className="sr-only">Submit subscription</span>
                </button>
              </div>
              <div className="subscribe__privacy">
                Your{" "}
                <Link to="/page/privacy-policy/" target="_blank">
                  <strong>privacy</strong>
                </Link>{" "}
                is assured
              </div>
            </form>
          </motion.div>
        ) : (
          <motion.div {...motionProps} className="subscribe__box" key={1}>
            <div className="subscribe__icon subscribe__icon--check">
              <CheckIcon />
            </div>
            <div>
              <h3 className="h3">Thanks for your subscription</h3>
              <p className="p-md">
                Please check your email to confirm your subscription
              </p>
            </div>
          </motion.div>
        )} */}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

const Subscribe = ({cls = ''}) => {
  return (
    <HubspotProvider>
      <HubspotSubscribeForm cls={cls} />
    </HubspotProvider>
  );
};

export default Subscribe;
